import { translate } from "app/filters/i18nFilter";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import {
    StyledSectionSubtitle,
    StyledSectionHeaderWrapper,
    StyledSectionTitle,
} from "app/pages/sales-intelligence/pages/manage-integration/styles/styles";
import { getCrmName } from "app/pages/sales-intelligence/utils/crm";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

const IntegrationSettingsHeader = () => {
    const { integrationName: crm } = getIntegrationNameFromUrl();
    const crmName = getCrmName(crm as Integration);

    return (
        <StyledSectionHeaderWrapper>
            <StyledSectionTitle>{translate("si.manage-integration.settings.title", { crmName })}</StyledSectionTitle>
            <StyledSectionSubtitle>{translate("si.manage-integration.settings.subtitle")}</StyledSectionSubtitle>
        </StyledSectionHeaderWrapper>
    );
};

export default IntegrationSettingsHeader;
